import lodash from "lodash";
import Base from "../base.store";

const baseUrl = "/api/v1/transaction/user-requests";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        request(context, { data, config }) {
            return base.request.put(`${baseUrl}/request`, data, { ...config });
        },
        requestWaitReceiveCustoms(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/wait-receive-customs`, JSON.stringify(id), { ...config });
        },
        requestReEdit(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/re-edit`, JSON.stringify(id), { ...config });
        },
        requestNotReceiveCustoms(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/not-receive-customs`, JSON.stringify(id), { ...config });
        },
        requestWaitApproveCenter(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/wait-approve-center`, JSON.stringify(id), { ...config });
        },
        requestNotReceiveCenter(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/not-receive-center`, JSON.stringify(id), { ...config });
        },
        requestWaitDocCustoms(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/wait-doc-customs`, JSON.stringify(id), { ...config });
        },
        requestApprove(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/approve`, JSON.stringify(id), { ...config });
        },
        requestNotApprove(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/not-approve`, JSON.stringify(id), { ...config });
        },
        requestCancel(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/cancel`, JSON.stringify(id), { ...config });
        },
        requestApproveOfficer(context, { id, config }) {
            return base.request.put(`${baseUrl}/request/approve-officer`, JSON.stringify(id), { ...config });
        },
        requestNotApproveOfficer(context, { data, config }) {
            return base.request.put(`${baseUrl}/request/not-approve-officer`, data, { ...config });
        },
        reStatus(context, { data, config }) {
            return base.request.put(`${baseUrl}/request/re-status`, data, { ...config });
        }
    },
    mutations: {
        ...base.mutations
    }
};
